import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withTranslation  } from 'react-i18next';
import { useForm } from "react-hook-form";


import {
    ThemeProvider,
    createMuiTheme,
  } from '@material-ui/core/styles';


const localTheme = createMuiTheme({
    palette: {
        primary:      {main: "#941F7A"},
        secondary:    {main: "#941F7A"},
        error:        {main: '#941F7A'},
        warning:       {main: '#941F7A'},
        info:        {main: '#941F7A'},
        background: {default: "#941F7A"},
        
      text: {
          primary: '#F3F5F5',
          secondary: '#F3F5F5'
      }
    },
  });

   
function ContactForm({t, i18n}) {
    var innerBox = { 
        padding: '2%',
        background: '#2F2E41',
        margin: 'auto',
        width: '50%'

    };
    
    var outerBox = { 
        padding: '2%',
        marginBottom: '20px',
        background: '#2F2E41',
    };

    var textAreaStyle = { 
        
        paddingTop: '1%',
        paddingLeft: '5%',
        marginLeft: '5%',
    };

    var textFieldStyle = { 
        marginTop: '1%',
        //paddingTop: '5%',
        borderColor: '#F3F5F5',
        background:'#F3F5F5',
        height: 30,
        width: '100%',
        border: 'auto',
        borderRadius: '5px',
        textAlign: 'left'
    };

     var messageFieldStyle = { 
        ...textFieldStyle,
        height: 120,
    };

    var buttonStyle = { 
       
        borderColor: '#F3F5F5',
        background:'#F3F5F5',
        border: 'auto',
        borderRadius: '5px',
        width: 80,
        height: 30,
        marginTop: 20
    };

    
  
    React.useEffect(()=>{
        console.log("Contact Form useEffect");
        const nameInput = document.getElementsByTagName('input');
        const form = document.querySelector('form');

       if(nameInput){
            nameInput.name.addEventListener('input', () => {
            nameInput.name.setCustomValidity('');
            nameInput.name.checkValidity();
            });

            nameInput.name.addEventListener('invalid', () => {           
                nameInput.name.setCustomValidity(t('Required Field'));
            });

            nameInput.email.addEventListener('input', () => {
            nameInput.email.setCustomValidity('');
            nameInput.email.checkValidity();
            });

            nameInput.email.addEventListener('invalid', () => {
                nameInput.email.setCustomValidity(t('Required email'));
            });
       }
    })
    const { register, handleSubmit, watch, errors } = useForm();
    const onSubmit = data => console.log(data);
    return (

        <form 
            name="reedbasketcontact" 
            method="post"
            action="./thankyou"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            id="Contact"
        > 
           
            <input type="hidden" name="bot-field" />
            <Grid container  style={outerBox} >
  
                <Grid container xs={10} style={innerBox} >
                    <Grid item xs={12} >
                      <Typography variant="h4" color="textSecondary" style={{paddingTop:'2%'}}>
                        {t('Learn more')}
                      </Typography> 
                      <Typography variant="h5" color="textSecondary" style={{paddingTop:'2%'}}>
                        {t('We are calling you back')}
                      </Typography> 
                    </Grid>
                    <Grid item xs={12} >
                        
                        <Typography variant="h5" color="textSecondary" style={{paddingTop:'2%'}}>
                            {t('Contact Name')}
                        </Typography> 
                           
                        <input id="inputText" type="text" name="name" id="name" style={textFieldStyle} required/>
                        {/* errors will return when field validation fails  */}
                        {errors.exampleRequired && <span>This field is required</span>}                  
                    </Grid>
                    <Grid item xs={12} >
                        <Typography variant="h5" color="textSecondary" style={{paddingTop:'2%'}}>
                            {t('Email')}
                        </Typography> 
                        
                        <input type="email" name="email" id="email" style={textFieldStyle} required/>
                         {/* errors will return when field validation fails  */}
                         {errors.exampleRequired && <span>This field is required</span>}
                    </Grid>
                    <Grid item xs={12} >
                        <Typography variant="h5" color="textSecondary" style={{paddingTop:'2%'}}>
                            {t('Phone')}
                        </Typography> 
                        <input type="tel" name="phone" id="phone" style={textFieldStyle} required/>
                    </Grid>
                    <Grid item xs={12} >
                        <Typography variant="h5" color="textSecondary" style={{paddingTop:'2%'}}>
                            {t('Message')}
                        </Typography> 
                        <textarea  type="text" rows="4" cols="60" name="message" id="message" style={messageFieldStyle}/>
                    </Grid>
                    <Grid item xs={6} >
                        
                            <button name="button" id="sendButton" style={buttonStyle}  type="submit">{t("Send")}</button> 
                        
                    </Grid>
                </Grid>
            </Grid>
        </form>
     

    );
   
}
export default withTranslation('landing') (ContactForm)
